export const PeriodSelectType = {
    ANNUAL: 1,
    PERIOD: 2
};


// WEBPACK FOOTER //
// ./src/enuns/AfterSales/summarySearchType.enum.js